import { createSlice } from "@reduxjs/toolkit";
import { userProfile } from "../actions/userProfileAction";

const initialState={
    loading:false,
    profileInfo:null,
    error:null,
    success:false
}

const profileSlice = createSlice({
    name:"user-profile",
    initialState,
    extraReducers:(builder)=>{
        builder
        .addCase(userProfile.pending, (state) => {
            state.loading = true;
            state.error = null;
            state.success =false;
        })
        .addCase(userProfile.fulfilled, (state,{payload}) => {
            state.loading=false;
            state.profileInfo=payload;
            state.success=true;
            state.error=null;
        })
        .addCase(userProfile.rejected,(state, {paylaod})=>{
            state.loading=false;
            state.error=paylaod;
            state.success=false;
        })
    }
});

export default profileSlice.reducer;